import detailForm from './form.vue';
export default {
  name: 'history-form',
  components: {
    detailForm: detailForm
  },
  props: {
    id: {
      required: true
    },
    uid: {
      default: function _default() {
        return undefined;
      }
    }
  }
};